import React from "react";
import "./style.scss";

const TableRow = ({className, children}) => <div className={`row table-row ${className || ""}`}>{[children]}</div>;

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/Table/TableRow/index.jsx